// extracted by mini-css-extract-plugin
export default {"container":"AddImage-container___sHAX6"};